<div class="comment-container" *ngIf="workflowDetailClientService.selectedStep$ | async as selectedStep">
  <div class="comment-display" *ngIf="showDisplay">
    <span class="comment-text" [class.no-comment]="!comment" (click)="toggleEdit()">
      <div *ngIf="!comment && readOnly" style="cursor: default">
        Kein Kommentar vorhanden
      </div>
      <div *ngIf="!comment && !readOnly">
        Kommentar hinzufügen
      </div>
      <div *ngIf="comment">
        {{ commentStripped(110) }}
      </div>
    </span>

    <i class="pi pi-info-circle info-icon"
       *ngIf="selectedStep.comment?.commentCreated && comment"
       [pTooltip]="'Erstellt: ' + (selectedStep.comment.commentCreated | date: 'dd.MM.yyyy HH:mm') + '\nVon: ' + selectedStep.comment.commentCreatedBy"
       tooltipPosition="top">
    </i>

    <button
      pButton
      type="button"
      icon="pi pi-pencil"
      class="p-button-rounded p-button-text p-button-sm edit-button"
      *ngIf="!readOnly"
      (click)="toggleEdit()">
    </button>
  </div>

  <div class="comment-edit" *ngIf="isEditing" @expandCollapse (@expandCollapse.done)="onEditAnimationDone($event)">
    <core-input-text-area
      #commentInput
      [ngModel]="comment"
      (ngModelChange)="onCommentChange($event)"
      [rows]="5"
      [disabled]="readOnly"
      [placeholder]="readOnly ? '' : 'Kommentar eingeben...'"
      [removeDefaultBottomErrorMargin]="true"
      [showClearButton]="false"
      (onKeyUpEnter)="saveComment()"
      (blur)="saveComment()">
    </core-input-text-area>
    <button
      pButton
      type="button"
      [icon]="readOnly ? 'pi pi-times' : 'pi pi-check'"
      class="p-button-rounded p-button-text p-button-sm"
      (click)="saveComment()">
    </button>
  </div>
</div>
